import { render, staticRenderFns } from "./OrderSummary.vue?vue&type=template&id=ec5a1bdc&scoped=true&"
import script from "./OrderSummary.vue?vue&type=script&lang=js&"
export * from "./OrderSummary.vue?vue&type=script&lang=js&"
import style0 from "./OrderSummary.vue?vue&type=style&index=0&id=ec5a1bdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5a1bdc",
  null
  
)

export default component.exports